import React,{Fragment} from 'react';
import './index.scss';
import url from '../../../../api/base-url';
import DataGrid, {Column} from 'devextreme-react/data-grid';
import {createStore} from "devextreme-aspnet-data-nojquery";
import sessions from '../../../../sessions';

export default function DeliveryExceptions(){
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    function getConfig(options) {  
        options.onBeforeSend = function(method, ajaxOptions) {  
            ajaxOptions.headers = {  
               "x-access-token": auth
            }  
        }  
        return options;  
    };
    const AllOrdersDataSource = createStore(getConfig({
        key: '_id', 
        loadUrl: `${url}/admin/shipments/delivery-exceptions`
    }));
    
    const trackingNoLink = (data) => {
        var no = data.data.tracking_number;
        return(
            <div>
                 <a target="_blank" href={`https://tools.usps.com/go/TrackConfirmAction.action?tLabels=${no}`}>{no}</a>
            </div>
        );
    }
return(
    <Fragment>
    <h4 className={'content-block'}>Delivery Exceptions</h4>
    <div className={'content-block'}>
        <DataGrid 
            dataSource={AllOrdersDataSource}
            showBorders={true}
            allowColumnResizing={true}
            columnAutoWidth={true}
            columnResizingMode={'nextColumn'}    
        >
        <Column dataField={'orderNo'}/>
        <Column dataField={'tracking_number'} caption={'Tracking Number'} cellRender={trackingNoLink}/>
        <Column dataField={'serviceType'}/>
        <Column dataField={'service'}/>
        <Column dataField={'name'} caption={'Recipient'}/>
        <Column dataField={'shipDate'} caption={'Ship Date'} dataType="date"/>
        <Column dataField={'LabelPrinted'} caption={'label Printed'}/>
        </DataGrid>
    </div>
</Fragment>

)};